export const toSearchParams = <T extends Record<string, unknown>>(obj: T): URLSearchParams => {
  const params = new URLSearchParams();

  Object.entries(obj).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      params.append(key, String(value));
    }
  });

  return params;
};
